import { Component, OnInit } from '@angular/core';
import { ITransaction } from '../../shared/interfaces/ITransaction';
import { PatMemberFacility } from '../../shared/models/pat-member-facility';

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrls: ["./page-not-found.component.scss"],
})

export class PageNotFoundComponent implements OnInit, ITransaction<PatMemberFacility> {
  constructor() {}
  saveTransaction(payload: any): PatMemberFacility {
    throw new Error("Method not implemented.");
  }
  navigateTransaction(payload: any): PatMemberFacility {
    throw new Error("Method not implemented.");
  }
  transactionById(payload: any): PatMemberFacility {
    throw new Error("Method not implemented.");
  }
 
  

  ngOnInit() {}
}
